import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';

Vue.use(Vuetify);

const opts = {
  theme: {
    dark: true,
    themes: {
      light: {
        primary: '#e3000b',
        secondary: '#495057',
        accent: '#ff7178',
        error: '#FF5252',
        info: '#2196F3',
        success: '#4CAF50',
        warning: '#FFC107',
      },
      dark: {
        background: '#e3000b',
        primary: '#ffffff',
        secondary: '#495057',
        accent: '#FF4081',
        error: '#E7FFBC',
        info: '#2196F3',
        success: '#4CAF50',
        warning: '#FB8C00',
      },
    },
    options: {
      variations: false,
      customProperties: true,
    },
    breakpoint: {
      thresholds: {
        xs: 0,
        sm: 637,
        md: 985,
        lg: 1440,
      },
    },
  },
}


export default new Vuetify(opts);
